module.exports = __webpack_public_path__ + "static/media/iconVn.04efb55a.svg";